import { render, staticRenderFns } from "./FactoryChange.vue?vue&type=template&id=28a88fc9&scoped=true"
import script from "./FactoryChange.vue?vue&type=script&lang=ts"
export * from "./FactoryChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a88fc9",
  null
  
)

export default component.exports